import { gql, useMutation } from "@apollo/client";

const CANCEL_SCHEDULED_COLLECTION_SYNC = gql`
  mutation CancelScheduledCollectionSync($id: String!) {
    cancelScheduledCollectionSync(id: $id) {
      id
      status
      canceledBy
      canceledByName
    }
  }
`;

const RUN_SCHEDULED_COLLECTION_SYNC_NOW = gql`
  mutation RunScheduledCollectionSyncNow($id: String!) {
    runScheduledCollectionSyncNow(id: $id) {
      id
      status
      executedAt
      startedBy
    }
  }
`;

interface OutputProps {
  cancelLoading: boolean;
  runNowLoading: boolean;
  onCancelScheduledSync: (id: string) => Promise<unknown>;
  onRunScheduledSyncNow: (id: string) => Promise<unknown>;
}

export default function useScheduledSyncMutations(): OutputProps {
  const [cancelScheduledSync, { loading: cancelLoading }] = useMutation(
    CANCEL_SCHEDULED_COLLECTION_SYNC
  );
  const [runScheduledSyncNow, { loading: runNowLoading }] = useMutation(
    RUN_SCHEDULED_COLLECTION_SYNC_NOW
  );

  async function onCancelScheduledSync(id: string): Promise<unknown> {
    return await cancelScheduledSync({ variables: { id } });
  }

  async function onRunScheduledSyncNow(id: string): Promise<unknown> {
    return await runScheduledSyncNow({ variables: { id } });
  }

  return {
    cancelLoading,
    runNowLoading,
    onCancelScheduledSync,
    onRunScheduledSyncNow,
  };
}
